import lazyAssetsObserver from 'js/lib/lazy_assets'
import SearchInfiniteScroll from 'js/search_infinite_scroll';
import SearchResultCards from 'js/searches/search_result_cards'

Searches            = LP.module('Searches')
FragmentHighlighter = Searches.FragmentHighlighter
Collections         = LP.module('Collections')

class SearchStore extends FluxBaseStore
  @storeName: 'SearchStore'

  @handlers:
    RECEIVE_SEARCH: 'updatePage'

  updatePage: ({rawSearch}) ->
    @dispatcher.waitFor 'ParamStore', =>
      $('#js-search-heading').html rawSearch.heading
      $('#search-results').html rawSearch.results
      $('.js-search-keywords').val @dispatcher.getStore('ParamStore').get('keywords')
      FragmentHighlighter.highlight keywords: @dispatcher.getStore('ParamStore').get('keywords')
      lazyAssetsObserver.observe()
      Searches.initializeTooltip()
      SearchResultCards.allowToBeAddedToCollections()
      LP.module('Popovers').init()
      @_resultsCount = rawSearch.raw_results_count

      if LP.config.withInfiniteScroll
        SearchInfiniteScroll.init()
      @emitChange()

Searches.SearchStore = SearchStore
